/**
 * Фильтр X6 History (beforeAddCommand).
 *
 * Стек undo/redo для графа мы не накапливаем: глобальная история — на сервере
 * (структурные версии и коллаборация). Возврат `false` — не добавлять команду в локальный History.
 *
 * Вызов из addCommand:
 *   FunctionExt.call(before, this, event, args)
 * то есть before.call(historyPlugin, event, args).
 * В колбэк попадают РОВНО ДВА аргумента:
 *   1) event — строка подписки: 'cell:added' | 'cell:removed' | 'cell:change:*'
 *   2) args — объект модели: { cell, key?, options?, ... }
 * Экземпляр History — это this, не первый параметр (если нужен — обычная function + this).
 */
import type {History, ModelEventArgs} from '@antv/x6';
import type {HistoryModelEvents} from '@antv/x6/lib/plugin/history/type';

export function canvasHistoryBeforeAddCommand<T extends HistoryModelEvents>(
	this: History,
	_event: T,
	_args: ModelEventArgs[T]
): boolean {
	return false;
}
